import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as Urls from 'src/constants/EndpointUrls';
import { Pulldown } from 'jbc-front/components/icons';
import { getCurrentUserInfo } from 'src/reducers/users/currentUser';
import { withTranslation, useTranslation } from 'react-i18next';

import styles from '../Settings.scss';

const CoordinationServiceList = () => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <a href={Urls.COORDINATION_SERVICE_LIST}>
        <dl className={styles.definition}>
          <dt>
            <span className={styles.icon}>
              <Pulldown size={13} />
            </span>
            {t('features.Settings.Settings.service_link')}
          </dt>
          <dd>{t('features.Settings.Settings.Linkable_with_Jobcan_services')}</dd>
        </dl>
      </a>
    </React.Fragment>
  );
};

class Settings extends React.Component {
  state = {
    isModalOpen: false
  };

  render() {
    const { planType } = this.props;

    return (
      <React.Fragment>
        <div className={styles.main}>
          <section className={styles.section}>
            <h3 className={styles.category}>{this.props.t('features.Settings.Settings.general')}</h3>
            <ul className={styles.list}>
              <li>
                <a href={Urls.LIST_COMPANY_URL}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.office_information')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_office_information')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.CLIENT_PAYROLL_RULES_GROUP_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.EmployeePays.components.DownloadColumnDetail.salary_rules')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_salary_rule')}</dd>
                  </dl>
                </a>
              </li>
              {/* <li>
                <a href={Urls.CLIENT_BONUS_ALLOWANCES_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.bonus_rule')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_bonus_rule')}</dd>
                  </dl>
                </a>
              </li> */}
              {/* <li>
                <a href={Urls.CLIENT_COMMUTING_FEE_SETTINGS}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.commuting_allowance_upper_limit_setting')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.Can_set_the_upper_limit_for_Commuting_allowance')}</dd>
                  </dl>
                </a>
              </li> */}
              <li>
                <a href={Urls.CLIENT_ALLOWANCE_ITEMS}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.attendance_item')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_attendance_item')}</dd>
                  </dl>
                </a>
              </li>
              {/* <li>
                <a href={Urls.CLIENT_RESIDENT_TAX_PAYMENTS_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.resident_tax_payment_destination')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.can_set_the_residence_tax_payment_destination')}</dd>
                  </dl>
                </a>
              </li> */}
              <li>
                <a href={Urls.CLIENT_CSV_FORMATS_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.provision_and_deduction_list_format_setting')}
                    </dt>
                    <dd>
                      {this.props.t('features.Settings.Settings.you_can_create_and_change_the_format_of_provision_and_deduction_list')}
                    </dd>
                  </dl>
                </a>
              </li>
              <li>
                <CoordinationServiceList planType={planType} />
              </li>
              <li>
                <a href={Urls.EMAIL_NOTIFICATION_SETTING}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.mail_alert_setting')}
                    </dt>
                    <dd>
                      {this.props.t(
                        'features.Settings.Settings.can_set_up_email_alert_for_attendance_data_integration_and_payment_confirmation'
                      )}
                    </dd>
                  </dl>
                </a>
              </li>
              {/* @TODO: Hide Provident Fund for Vietnam */}
              {/* https://donuts-vn.atlassian.net/browse/JBC-25 */}
              {/*
               <li>
                <a href={Urls.CLIENT_PROVIDENT_FUND_EDIT}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.provident_fund_setting')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_provident_fund_setting')}</dd>
                  </dl>
                </a>
              </li>
              */}
            </ul>
          </section>
          <section className={styles.section}>
            <h3 className={styles.category}>{this.props.t('features.Settings.Settings.organization_management')}</h3>
            <ul className={styles.list}>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=groups`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Employees.components.BusinessInfoSection.group')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_group')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=occupations`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.occupation')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_occupation')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=positions`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Employees.components.BusinessInfoSection.position')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_occupation')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={`${Urls.COORDINATIONS_SETTING_CLIENT_DEPARTMENT}?tab=employment_types`}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.EmployeeBonus.components.EmployeeBonusTable.employment_type')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_employment_status')}</dd>
                  </dl>
                </a>
              </li>
            </ul>
            {/* <div className={styles.button}>
              <ActionButton
                icon={<Link size={15} />}
                onClick={() => this.setState({ ...this.state, isModalOpen: true })}
              >
                組織管理の連携設定
              </ActionButton>
              <CoordinationWithRoumuModal
                isOpen={this.state.isModalOpen}
                hideModal={() => this.setState({ ...this.state, isModalOpen: false })}
              />
            </div> */}
          </section>
          <section className={styles.section}>
            <h3 className={styles.category}>{this.props.t('features.Settings.Settings.other')}</h3>
            <ul className={styles.list}>
              {/* <li>
                <a href={Urls.CLIENT_SETTING_USING_PLAN}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>{this.props.t('features.Settings.Settings.plan_in_use')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_check_current_plan_and_billing_information')}</dd>
                  </dl>
                </a>
              </li> */}
              <li>
                <a href={Urls.CLIENT_ROLE_USERS_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.authority_management_setting')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_change_authority')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.AUDIT_LOGS_LIST}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.operation_history')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_check_history_of_changes_made')}</dd>
                  </dl>
                </a>
              </li>
              <li>
                <a href={Urls.ALLOWED_IP_SETTING}>
                  <dl className={styles.definition}>
                    <dt>
                      <span className={styles.icon}>
                        <Pulldown size={13} />
                      </span>
                      {this.props.t('features.Settings.Settings.IP_address_restriction')}
                    </dt>
                    <dd>{this.props.t('features.Settings.Settings.you_can_set_an_IP_address_connection_restriction')}</dd>
                  </dl>
                </a>
              </li>
            </ul>
          </section>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  planType: _.get(state, 'currentClient.item.data.planType'),
  currentUser: getCurrentUserInfo(state) || {}
});

export default withTranslation()(connect(mapStateToProps)(Settings));
